module.exports = __webpack_public_path__ + "static/media/icono_semola.7d0d09df.png";